import React            from 'react';
import Moment           from 'moment';
import { Line, Chart }         from 'react-chartjs-2';
import {
	chart1_4_options,
	chartExample3
}                       from "variables/charts.js";
import { extendMoment } from 'moment-range/dist/moment-range.js';
import Button
						from 'reactstrap/es/Button';
const plug = {
	id: 'percent',
	beforeDatasetsUpdate: (chart, a) => {
		//loop each dataset
		chart.data.datasets.forEach(dataset => {
			//for each data index - we need to find the maximum value
			if (dataset.isOriginal) {
				var max = 0;
				for (var i = 0; i < dataset.data.length; i++) {
					if (parseFloat(dataset.data[i]) > max) {
						max = parseFloat(dataset.data[i]);
					}
				}

				for (var i = 0; i < dataset.data.length; i++) {
					//set the data to be a percentage?
					dataset.data[i] = ((dataset.data[i] / max) * 100).toFixed(2);
				}
			}

			dataset.isOriginal = false;
		})

	}
}

Chart.pluginService.register(plug);

class MarketingChart extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			Interval: 'daily',
			Labels: []
		}
		this.moment = extendMoment(Moment);
		this.salesChart = {
			all: canvas => {
				let ctx = canvas.getContext("2d");

				let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

				gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
				gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
				gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

				return {
					labels: this.state.Labels,
					datasets: this.processData(gradientStroke)
				};
			},
		}
		this.repReference = React.createRef();
	}

	processData = (gradientStroke) => {
		var r1 = '#'+Math.random().toString(16).slice(-6);
		var r2 = '#'+Math.random().toString(16).slice(-6);
		var r3 = '#'+Math.random().toString(16).slice(-6);
		var r4 = '#'+Math.random().toString(16).slice(-6);
		var r5 = '#'+Math.random().toString(16).slice(-6);
		var r6 = '#'+Math.random().toString(16).slice(-6);
		var r7 = '#'+Math.random().toString(16).slice(-6);
		var r8 = '#'+Math.random().toString(16).slice(-6);
		var r9 = '#'+Math.random().toString(16).slice(-6);
		var r10 = '#'+Math.random().toString(16).slice(-6);
		var r11 = '#'+Math.random().toString(16).slice(-6);
		var r12 = '#'+Math.random().toString(16).slice(-6);
		var r13 = '#'+Math.random().toString(16).slice(-6);


		var labels = [];
		var l = [];
		//format labels
		switch(this.props.interval) {
			case 'hours':
				var range1 = this.moment.range(this.props.dateStart, this.props.dateEnd);
				//generate an array of every hour from start to end date
				l = Array.from(range1.by('h'));
				break;
			case 'daily':
				var de = Moment(this.props.dateEnd).add(1, 'days');
				var range1 = this.moment.range(this.props.dateStart, de);
				l = Array.from(range1.by('d'));
				break;
			case 'weekly':
				var de = Moment(this.props.dateEnd).add(1, 'week');
				var range1 = this.moment.range(this.props.dateStart, de);
				l  = Array.from(range1.by('w'));
				break;
			case 'monthly':
				var de = Moment(this.props.dateEnd).add(1, 'month');
				var range1 = this.moment.range(this.props.dateStart, de);
				l = Array.from(range1.by('M'));
				break;
		}
		l.forEach( i => {
			labels.push(i.format('YYYY-MM-DD HH:00'));
		});

		if (this.state.Labels.join(' ') != labels.join(' ')) {
			this.setState({Labels: labels});
		}


		var baseData = {
			spend: {
					label: "Spend",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r1,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r1, //"#1f8ef1",
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r1, //"#1f8ef1",
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			leads: {
					label: "Leads",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r2,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r2,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r2,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					isOriginal: true,
					data: [],
					originalData: []
				},
			cpl: {
					label: "CPL",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r3,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r3,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r3,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			appointments: {
					label: "Appointments",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r4,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r4,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r4,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			crAppointments: {
					label: "CR APP",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r5,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r5,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r5,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			costApp: {
					label: "Cost APP",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r6,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r6,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r6,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			sales: {
					label: "Sales",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r7,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r7,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r7,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			crSales: {
					label: "CR Sales",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r8,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r8,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r8,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			costSales: {
					label: "Cost Sales",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r9,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r9,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r9,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			revenue: {
					label: "Revenue",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r10,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r10,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r10,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			avgSale: {
					label: "Avg Sale",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r11,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r11,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r11,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			salesRate: {
					label: "Sales Rate",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r13,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r13,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r13,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
			roas: {
					label: "ROAS",
					fill: true,
					backgroundColor: gradientStroke,
					borderColor: r12,
					borderWidth: 2,
					borderDash: [],
					borderDashOffset: 0.0,
					pointBackgroundColor: r12,
					pointBorderColor: "rgba(255,255,255,0)",
					pointHoverBackgroundColor: r12,
					pointBorderWidth: 20,
					pointHoverRadius: 4,
					pointHoverBorderWidth: 15,
					pointRadius: 4,
					data: [],
					originalData: []
				},
		};

		Object.keys(baseData).forEach((ii, v) => {
			for (var i = 0; i < labels.length; i++) {
				baseData[ii].data[i] = 0;
			}
		})


		//loop over the keys and then match all the data
		for (var i = 0; i < labels.length; i++) {
			var d = Moment(labels[i]);
			var data = this.props.data.find(i => {
				return Moment(i.Day).format('x') == d.format('x');
			})
			if (data) {
				//we have a data block for this date
				baseData['spend'].data[i] = data.SpendTotal;
				baseData['spend'].originalData[i] = data.SpendTotal;
				baseData['spend'].isOriginal = true;

				baseData['leads'].data[i] = data.LeadTotal;
				baseData['leads'].originalData[i] = data.LeadTotal;
				baseData['leads'].isOriginal = true;

				baseData['cpl'].data[i] = data.LeadTotal > 0 ?(data.SpendTotal / data.LeadTotal).toFixed(2) : 0;
				baseData['cpl'].originalData[i] = data.LeadTotal > 0 ?(data.SpendTotal / data.LeadTotal).toFixed(2) : 0;
				baseData['cpl'].isOriginal = true;

				baseData['appointments'].data[i] = data.BookedTotal;
				baseData['appointments'].originalData[i] = data.BookedTotal;
				baseData['appointments'].isOriginal = true;

				baseData['crAppointments'].data[i] = data.LeadTotal > 0 ?(100 * (data.BookedTotal / data.LeadTotal)).toFixed(2) : 0;
				baseData['crAppointments'].originalData[i] = data.LeadTotal > 0 ?(100 * (data.BookedTotal / data.LeadTotal)).toFixed(2) : 0;
				baseData['crAppointments'].isOriginal = true;

				baseData['costApp'].data[i] = data.BookedTotal == 0 ? data.SpendTotal : (data.SpendTotal / data.BookedTotal).toFixed(2);
				baseData['costApp'].originalData[i] = data.BookedTotal == 0 ? data.SpendTotal : (data.SpendTotal / data.BookedTotal).toFixed(2);
				baseData['costApp'].isOriginal = true;

				baseData['sales'].data[i] = data.SoldTotal;
				baseData['sales'].originalData[i] = data.SoldTotal;
				baseData['sales'].isOriginal = true;

				baseData['crSales'].data[i] = data.BookedTotal > 0 ? (100 * (data.SoldTotal / data.BookedTotal)).toFixed(2) : 0;
				baseData['crSales'].originalData[i] = data.BookedTotal > 0 ? (100 * (data.SoldTotal / data.BookedTotal)).toFixed(2) : 0;
				baseData['crSales'].isOriginal = true;

				baseData['costSales'].data[i] = data.SoldTotal > 0 ? (data.SpendTotal / data.SoldTotal).toFixed(2) : 0;
				baseData['costSales'].originalData[i] = data.SoldTotal > 0 ? (data.SpendTotal / data.SoldTotal).toFixed(2) : 0;
				baseData['costSales'].isOriginal = true;

				baseData['revenue'].data[i] = data.RevenueTotal;
				baseData['revenue'].originalData[i] = data.RevenueTotal;
				baseData['revenue'].isOriginal = true;

				baseData['avgSale'].data[i] = data.SoldTotal > 0 ? (data.RevenueTotal / data.SoldTotal).toFixed(2) : 0;
				baseData['avgSale'].originalData[i] = data.SoldTotal > 0 ? (data.RevenueTotal / data.SoldTotal).toFixed(2) : 0;
				baseData['avgSale'].isOriginal = true;

				baseData['salesRate'].data[i] = data.LeadTotal > 0 ? (100 * (data.SoldTotal / data.LeadTotal)).toFixed(2) : 0;
				baseData['salesRate'].originalData[i] = data.LeadTotal > 0 ? (100 * (data.SoldTotal / data.LeadTotal)).toFixed(2) : 0;
				baseData['salesRate'].isOriginal = true;

				baseData['roas'].data[i] = data.SpendTotal > 0 ? ((data.RevenueTotal / data.SpendTotal)).toFixed(2) : 0;
				baseData['roas'].originalData[i] = data.SpendTotal > 0 ? ((data.RevenueTotal / data.SpendTotal)).toFixed(2) : 0;
				baseData['roas'].isOriginal = true;


			}
		}


		var retData = [];
		Object.keys(baseData).forEach((i, v) => {
			retData.push(baseData[i])
		});
		return retData;
	}

	toggleLegend = () => {
		this.repReference.current.chartInstance.data.datasets.forEach(function(ds) {
			ds.hidden = !ds.hidden;
		});
		this.repReference.current.chartInstance.update();

	}

	render() {
		//check if this is an empty chart, if so we need to draw a sad face
		if (this.props.data.length == 0) {
			return (
				<>
					<div className={`chart-area marketing-chart-area`}>

					</div>
				</>
			)
		}
		var isEmpty = true;
		this.props.data.some(i => {
			isEmpty = isEmpty && !(i.SpendTotal !== 0 || i.LeadTotal !== 0 || i.BookedTotal !== 0 || i.SoldTotal !== 0 || i.RevenueTotal !== 0);
			return i.SpendTotal !== 0 || i.LeadTotal !== 0 || i.BookedTotal !== 0 || i.SoldTotal !== 0 || i.RevenueTotal !== 0

		});
		if (this.props.data.length > 0 && isEmpty) {
			return (
				<>
					<div className={`chart-area marketing-chart-area`}>
						<div className={'marketing-chart--empty-text'}>
							<i className="fa fa-frown-o marketing-chart--empty-icon" aria-hidden="true"></i>
							<h4>There is no data for this period</h4>
						</div>
					</div>
				</>
			)
		}
		return (
			<>
				<Button className={`center-button`} onClick={this.toggleLegend} size={'sm'}>Show/Hide</Button>
				<div className={`chart-area marketing-chart-area`}>
				<Line
					ref={this.repReference}
					data={this.salesChart.all}
					//options={chartExample3.options}
					options={chart1_4_options}
				/>
				</div>
			</>
		)
	}
}

export default MarketingChart;
